import type { FC } from 'react';
import { generateChipClassNames } from '@/DesignSystem/Helper';
import type { IChipProps } from '@/DesignSystem/Model/DataModel';
const Chip: FC<IChipProps> = ({
  title,
  beforeIcon,
  afterIcon,
  ...props
}) => {
  return <span className={generateChipClassNames(props)} data-sentry-component="Chip" data-sentry-source-file="Chip.tsx">
      {beforeIcon && beforeIcon}
      {title ? <span>{title}</span> : null}
      {afterIcon && afterIcon}
    </span>;
};
Chip.defaultProps = {
  radius: 'round',
  size: 'middle'
};
export default Chip;